export default {
    Footer :{
        // height:"5vh",
        margin: "10px",
        display: "flex",
        justifyContent: "flex-end",
        alignItems: "center",
        overflowY: "hidden"
    },
    paletteName: {
        fontWeight: "bold",
        paddingRight: "10px"
    }
}